export const APP_URL_PREFIX = '/exchange-rates';

export const PAGE_INDICES = {
    LOGIN: 0,
    UPDATE: 1,
};

export const PAGES = [
    {
        URL: `${APP_URL_PREFIX}/login`,
        URL_PART: 'login',
        TITLE: 'Login',
    },
    {
        URL: `${APP_URL_PREFIX}/update`,
        URL_PART: 'update',
        TITLE: 'Update',
    },
];

export const TRAVEL_INSURANCE_URLS = {
    LOGIN: PAGES[PAGE_INDICES.LOGIN].URL,
    UPDATE: PAGES[PAGE_INDICES.UPDATE].URL,
};
